import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../ui/SEOHead';

export default function NotFoundPage() {
  return (
    <>
      <SEOHead title="Page Not Found" noindex />
      <section className="section" style={{minHeight:'60vh',display:'flex',alignItems:'center'}}>
        <div className="container" style={{textAlign:'center'}}>
          <div style={{fontSize:'80px',marginBottom:'24px'}}>🦷</div>
          <h1 className="display-heading" style={{marginBottom:'16px'}}>Page Not <em>Found</em></h1>
          <p style={{fontSize:'17px',fontWeight:'300',color:'var(--slate-600)',marginBottom:'32px',maxWidth:'400px',margin:'0 auto 32px'}}>Sorry, the page you're looking for doesn't exist. Let's get you back on track.</p>
          <div style={{display:'flex',gap:'14px',justifyContent:'center',flexWrap:'wrap'}}>
            <Link to="/" className="btn btn-primary btn-primary-lg">Go Home</Link>
            <Link to="/book-appointment" className="btn btn-outline">Book Appointment</Link>
          </div>
        </div>
      </section>
    </>
  );
}
